const HelpIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2123 6.26249C16.9498 3.78749 14.9248 1.76249 12.3748 1.42499C10.0498 1.16249 7.87477 2.32499 6.82477 4.34999C6.59977 4.76249 6.78727 5.28749 7.19977 5.47499C7.61227 5.69999 8.13727 5.51249 8.32477 5.09999C9.07477 3.67499 10.5748 2.88749 12.1873 3.03749C13.9498 3.26249 15.3373 4.68749 15.5248 6.37499C15.7123 7.98749 14.8498 9.52499 13.3873 10.2C11.8498 10.95 10.8748 12.525 10.8748 14.2875V18C10.8748 18.45 11.2498 18.8625 11.7373 18.8625C12.2248 18.8625 12.5998 18.4875 12.5998 18V14.2875C12.5998 13.2 13.2373 12.1875 14.1748 11.7375C16.2373 10.8375 17.4748 8.58749 17.2123 6.26249Z"
        fill="currentColor"
      />
      <path
        d="M11.7375 20.7C11.2875 20.7 10.875 21.075 10.875 21.5625V21.75C10.875 22.2 11.25 22.6125 11.7375 22.6125C12.225 22.6125 12.6 22.2375 12.6 21.75V21.5625C12.5625 21.075 12.1875 20.7 11.7375 20.7Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HelpIcon;
